import "./gradientButton.scss";
import PropTypes from "prop-types";

function GradientButton({ onPress, children, disabled = false }) {
  return (
    <button className="gradientButton" onClick={onPress} disabled={disabled}>
      {children}
    </button>
  );
}

GradientButton.propTypes = {
  onPress: PropTypes.func,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

export default GradientButton;
